import { render } from "./modal_openform.vue?vue&type=template&id=e63be312&scoped=true"
import script from "./modal_openform.vue?vue&type=script&lang=js"
export * from "./modal_openform.vue?vue&type=script&lang=js"

import "./modal_openform.vue?vue&type=style&index=0&id=e63be312&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63be312"]])

export default __exports__